module.exports = __webpack_public_path__ + "static/media/chih_yi_wu.50a3e065.jpg";